<template>
  <article>
    <div style="width: inherit;" v-if="this.component.name != 'CTE'" >
        <btnCTeVinculadas style="width: inherit;" v-if="nota.item.cte && nota.item.cte.length > 0" :nota="this.nota"></btnCTeVinculadas>
        <btnCCeVinculadas style="width: inherit;" v-if="nota.item.xmlCce && nota.item.xmlCce.length > 0" :nota="this.nota"></btnCCeVinculadas>
    </div>
    <div style="width: inherit;" v-else >
      <btnNFeVinculadas :nota="this.nota"></btnNFeVinculadas>
    </div>
    
  </article>
</template>
<script>
import btnCTeVinculadas from "./btnCTeVinculadas/BtnCTeVinculadas.vue";
import btnCCeVinculadas from "./btnCCeVinculadas/BtnCCeVinculadas.vue";
import btnNFeVinculadas from "./btnNFeVinculadas/BtnNFeVinculadas.vue";
export default {
  props: ["nota", "empresa", "component"],
  updated: function() {
    this.$nextTick(function() {});
  },
  beforeMount() {},
  data: () => ({
    openDialog: false
  }),
  components: {
    btnCTeVinculadas: btnCTeVinculadas,
    btnCCeVinculadas: btnCCeVinculadas,
    btnNFeVinculadas: btnNFeVinculadas
  },
  methods: {
    teste: function() {}
  }
};
</script>
<style>
.vinculoChip span.v-chip__content {
  cursor: pointer;
  font-size: 10px !important;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_vinculo/Coluna_Vinculo.vue